import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import clsx from 'clsx';
import { ReactComponent as EyeIcon } from '@fortawesome/fontawesome-free/svgs/solid/eye.svg';
import { ReactComponent as EyeSlashIcon } from '@fortawesome/fontawesome-free/svgs/solid/eye-slash.svg';

const Password = ({ formik }) => {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const toggleLabel = showPassword
      ? t("auth:login_box.input.password.hide")
      : t("auth:login_box.input.password.show");

    return (
        <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>{t("auth:login_box.input.password.label")}</label>
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '5px' }}
            >
              {t("auth:login_box.forgot_password_action")}
            </Link>
          </div>
        </div>
        <div className='auth-password-field'>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={t("auth:login_box.input.password.placeholder")}
            autoComplete='current-password'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )}
          />
          <button
            type='button'
            className='auth-password-toggle'
            aria-label={toggleLabel}
            aria-pressed={showPassword}
            title={toggleLabel}
            onClick={() => setShowPassword((visible) => !visible)}
          >
            {showPassword
              ? <EyeSlashIcon aria-hidden='true' focusable='false' />
              : <EyeIcon aria-hidden='true' focusable='false' />}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
    );
};

export default Password;
